<template>
	<div>
		<div class="mt-5 d-flex align-items-center justify-content-between">
			<router-link :to="getLink" class="d-flex align-items-center">
				<div class="avatar avatar--mini flex-shrink-0 me-1" :style="{ backgroundImage: `url(${post.author.avatar})` }"></div>
				<p class="mb-0">{{ getAuthorFullName }}</p>
			</router-link>
			<div>{{ getFormatDatePost }}</div>
		</div>
		<div class="mt-4">Comments: {{post?.comments.length}}</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { PropType } from 'vue/dist/vue';
import formatDate from '@/utils/formatDate';

interface Post {
	author: {
		_id: number,
		wpId: number,
		avatar: string
		firstName: string,
		lastName: string
	}
	title?: string
	description?: string
	authorContent?: string,
	comments?: [],
	metaInput?: {
		image: string,
		sourceUrl: string
	}
	created_at: string
}

export default defineComponent({
	name: 'PostCardFooter',
	props: {
		post: {
			type: Object as PropType<Post>,
			required: true
		},
		currentUserId: {
			required: true
		}
	},
	computed: {
		getLink(){
			return this.post.author.wpId === this.currentUserId ? '/' : `/person/?id=${this.post.author.wpId}`
		},
		getAuthorFullName(){
			return this.post.author.firstName + ' ' + this.post.author.lastName
		},
		getFormatDatePost(){
			return formatDate(this.post.created_at)
		}
	},
	data(){
		return {}
	},
	methods: {},
})
</script>
